<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized" class="event-link-chat">
  <div class="event-titles">
    <a href="https://behaviorlive.com/{{evt.discriminator}}s/{{evt.slug}}" target="_blank">
      {{evt.title}}</a>
    </div>
  <img class="img img-fluid" src="https://bxlimages.blob.core.windows.net/splash/{{evt.marketingSplashPath}}"/>
  <div class="speaker">{{evt.instructor.fullNameWithCredentials}}</div>
  <div *ngIf="evt.discriminator == 'event'" class="ceus"><strong>{{evt.originalAirDate | date}} {{evt.originalAirDate | date:'shortTime'}}</strong></div>
  <div class="ceus">{{evt.ceus | ceuDisplay }} CEU(s)</div>

  </div>
